module.exports = __webpack_public_path__ + "static/media/astrology.2bce8f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/astrology.png
// module id = 2318
// module chunks = 0